import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'safeUrl',
  standalone: true,
})
export class SafeUrlPipe implements PipeTransform {
  private readonly html = inject(DomSanitizer);

  public transform(html: string): SafeHtml {
    return this.html.bypassSecurityTrustUrl(html);
  }
}
